import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import { ArtifactNodeDisplayProps } from "@/types";
import { deltaStore, selectionStore, viewsStore } from "@/hooks";
import { NodeDisplay } from "@/components/graph/display";
import { Separator } from "@/components/common";
import { ArtifactNameDisplay } from "@/components/artifact";


/**
 * Renders the identifying content of an artifact node in the graph.
 */
const __default__ = {
  name: "ArtifactNodeDisplay",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    color: {},
    deltaColor: {},
    selected: { type: Boolean },
    artifact: {}
  },
  setup(__props: any) {

const props = __props;

const id = computed(() => props.artifact.id);
const showDelta = computed(() => deltaStore.inDeltaView);

/**
 * Selects an artifact and highlights its subtree,
 * or opens a new view of the artifact's subtree if the artifact is already selected.
 */
function handleSelect(selected = props.selected): void {
  if (!selected) {
    selectionStore.selectArtifact(id.value);
  } else {
    viewsStore.addDocumentOfNeighborhood({
      id: id.value,
      name: props.artifact.name,
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NodeDisplay), {
    separator: "",
    color: props.color,
    variant: "artifact",
    title: props.artifact.type,
    selected: props.selected,
    onClick: handleSelect,
    onDblclick: _cache[0] || (_cache[0] = ($event: any) => (handleSelect(true)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ArtifactNameDisplay), {
        align: "center",
        artifact: props.artifact,
        "is-header": "",
        dense: "",
        class: "cy-node-artifact-name",
        "data-cy": "tree-node-name"
      }, null, 8, ["artifact"]),
      (showDelta.value)
        ? (_openBlock(), _createBlock(_unref(Separator), {
            key: 0,
            color: props.deltaColor,
            class: "cy-node-delta-chip"
          }, null, 8, ["color"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["color", "title", "selected"]))
}
}

})